import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import { useGetLocationById } from "@services/location/getById";
import Heading from "@commons/Typography/Heading";
import Text from "@commons/Typography/Text";
import TableViewVisit from "../components/TableViewVisit";
import ModalNewVisit from "../components/modal/ModalNewVisit";
import ModalEditVisit from "../components/modal/ModalEditVisit";

function ViewLocation() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const { data: location, isLoading, error } = useGetLocationById(id ?? null);

  useEffect(() => {
    if (!isLoading && !location) {
      toast.warning("Localização não encontrada.");
      navigate("/community");
    }
    if (error) {
      toast.error("Erro ao carregar os dados de localização.");
      navigate("/community");
    }
  }, [isLoading, location, error, navigate]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <CircularProgress />
      </div>
    );
  }

  if (!location) return null;

  return (
    <section className="flex flex-col gap-4">
      <div className="bg-white rounded-xl shadow p-4 flex flex-col gap-2">
        <Heading className="mb-2">Informações da Localização</Heading>

        <Text>
          <Text component={"span"} className="font-medium">
            Responsáveis:
          </Text>{" "}
          {location.responsible || "—"}
        </Text>

        <Text>
          <Text component={"span"} className="font-medium">
            Localização:
          </Text>{" "}
          {location.address}
        </Text>

        <Text>
          <Text component={"span"} className="font-medium">
            Contato:
          </Text>{" "}
          {location.email || "—"}, {location.phone}
        </Text>

        <Text>
          <Text component={"span"} className="font-medium">
            Data de Registro:
          </Text>{" "}
          {new Date(location.createdAt).toLocaleDateString()}
        </Text>

        <Text>
          <Text component={"span"} className="font-medium">
            Código:
          </Text>{" "}
          {location.code}
        </Text>
      </div>

      <div className="bg-white rounded-xl shadow p-4">
        <TableViewVisit />
      </div>

      <ModalNewVisit />
      <ModalEditVisit />
    </section>
  );
}

export default ViewLocation;
